import { formatDate } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';
import { environment } from 'projects/packcert-web/src/environments/environment';
import { Subject } from 'rxjs';
import { AdminService } from '../../modules/admin/services/admin.service';

@Component({
  selector: 'app-map',
  templateUrl: './app-map.component.html'
})


export class MapsComponent implements OnInit {

  public showMap = false;
  public mapURLSader;

  private entidadControlId;
  private isAppReady = false;
  private gisParams: any = {};
  private paramsAlreadySent = false;

  @Input() app: string;
  @Input() open: number;
  @Input() codigoGsv: number;
  @Input() paisId: number;
  @Input() denominacionId: number;
  @Input() campanyaId: number;
  @Input() almacenId: number;
  @Input() etiquetadorId: number;
  
  @Output() closeMap = new EventEmitter<boolean>();

  // @HostListener('document:click', ['$event'])
  // clickout(event) {
  //   if (!this.eRef.nativeElement.contains(event.target)) {
  //       this.closeMap.emit(false);
  //   }
  // }

  constructor(private _fb: UntypedFormBuilder, private eRef: ElementRef, private renderer: Renderer2,
              private readonly _sessionContext: SessionContextService,
              private readonly _sanitizer: DomSanitizer,
              private readonly _translate: TranslateService,
              private readonly _adminService: AdminService,
  ) {
  }

  @HostListener('window:message', ['$event'])
  handleGisMessage(event: MessageEvent) {
    if (event.origin !== environment.denominacionGisEdicion) {
      return;
    }

    if (event.data?.type === 'editor-ready') {
      this.isAppReady = true;

      if (!this.needsEntidadControl() || this.entidadControlId) {
        this.sendGisParams();
      }
    }
  }

  ngOnInit() {
    this.mapURLSader = this._sanitizer.bypassSecurityTrustResourceUrl(environment.denominacionGisEdicion);
    this.getGisParams();

    if (this.needsEntidadControl()) {
      this.getEntidadControl().then(
        () => {
          if (this.isAppReady) {
            this.sendGisParams();
          }
        }, (error) => {
          console.log('Promise rejected with ' + JSON.stringify(error));
        }
      ).catch(e => console.log(e));
    } else if (this.isAppReady) {
      this.sendGisParams();
    }
  }

  private needsEntidadControl(): boolean {
    return this._sessionContext.sessionUser.role === 'Auditor' || this._sessionContext.sessionUser.role === 'Supervisor';
  }

  /**
   * Obtener la entidad de control (Auditor o Supervisor) y añadirla a los parámetros de GIS
   */
  private getEntidadControl(): Promise<any> {
    return new Promise((resolve, reject) => {
      const filters = {
        userName: this._sessionContext.sessionUser.userName
      };
      this._adminService.getEntidadesControl(filters).toPromise().then((resp) => {
        if (resp?.lista?.length) {
          this.entidadControlId = resp.lista[0].id;
          this.gisParams.userData.entidadControlId = this.entidadControlId;
        }
        setTimeout(resolve, 1);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  /**
   * Obtener los parámetros para Auditor o Administrador
   */
  private getGisParams() {
    this.gisParams = {
      userData: {
        app: this.app,
        token: this._sessionContext.sessionUser.token,
        rol: this._sessionContext.sessionUser.role,
        locale: this._translate.getDefaultLang(),
        open: this.open
      },
    };

    switch (this.app) {
      case 'CUL':
        this.gisParams.userData.codigoGsv = this.codigoGsv;
        this.gisParams.userData.paisId = this.paisId;
        this.gisParams.userData.denominacionId = this.denominacionId;
        this.gisParams.userData.campanyaId = this.campanyaId;
        break;
      case 'ALM':
        this.gisParams.userData.almacenId = this.almacenId;
        this.gisParams.userData.etiquetadorId = this.etiquetadorId;
        break;
    }

    // Mandamos también los estilos personalizados para Auditor
    if (this._sessionContext.sessionUser.role === 'Auditor') {
      this.gisParams.customStyles = localStorage.getItem('customStyles') || null;
    }
  }

  private sendGisParams() {
    if (!this.paramsAlreadySent) {
      const iframe = document.querySelector('iframe');
      iframe?.contentWindow?.postMessage(
        {
          type: 'gis-params',
          payload: this.gisParams,
        },
        environment.denominacionGisEdicion
      );

      this.paramsAlreadySent = true;
    }
  }
}
